//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CurrencyFormatInfo } from './CurrencyFormatInfo';
import { MembershipPlanCurrencyCode } from './Enums';

export class MembershipCurrencyDisplayItem extends ItemBase {
    CurrencyCode: MembershipPlanCurrencyCode = MembershipPlanCurrencyCode.AUD;
    FormatInfo: CurrencyFormatInfo | null = null;

    constructor(initializer?: Partial<MembershipCurrencyDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MembershipCurrencyDisplayItem";
}
